<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Add An Agent</p>
    </header>
    <section class="modal-card-body">
      <b-field label="Name">
        <b-input
          type="text"
          v-model="name"
          placeholder="Enter Name"
          required
        ></b-input>
      </b-field>
      <b-field label="Mobile Number">
        <b-input
          type="text"
          v-model="number"
          placeholder="Enter Mobile Number"
          required
        ></b-input>
      </b-field>
      <b-field label="Email">
        <b-input
          type="email"
          v-model="email"
          placeholder="Enter Agent Email"
          required
        ></b-input>
      </b-field>
      <b-field label="Max Ticket/Game">
        <b-input
          type="number"
          v-model="limit"
          placeholder="Enter Limit ex. 20"
          required
        ></b-input>
      </b-field>
      <b-field label="Password">
        <b-input
          type="password"
          v-model="password"
          placeholder="Enter Password"
          required
        ></b-input>
      </b-field>
    </section>
    <footer class="modal-card-foot">
      <button @click="submit()" class="button is-primary">Add Agent</button>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      number: "",
      email: "",
      limit: 20,
      password: "",
    };
  },
  methods: {
    submit() {
      if (this.number.length < 10) {
        return alert("Invalid mobile number!");
      }
      this.$emit("AddAgent", {
        name: this.name,
        number: this.number,
        limit: parseInt(this.limit),
        email: this.email.toLowerCase(),
        password: this.password,
      });
      this.$parent.close();
    },
  },
};
</script>